export default "__VITE_ASSET__BNMy1wYd__"